import React, { Fragment } from 'react'

import { AudioTrack } from '../AudioTrack/AudioTrack'
import { useRemoteParticipants } from '../../../webrtc/webRTCRoom'

const ParticipantsAudio = () => {
  const participants = useRemoteParticipants()

  return (
    <>
      {participants.map((p) => (
        <Fragment key={p.id}>
          {p.tracks.cameraAudio && (
            <AudioTrack track={p.tracks.cameraAudio} participantId={p.id} />
          )}
          {p.tracks.screenAudio && (
            <AudioTrack track={p.tracks.screenAudio} participantId={p.id} />
          )}
        </Fragment>
      ))}
    </>
  )
}

export { ParticipantsAudio }
